import * as _4 from 'lodash4';
import { PronounsQuery } from 'capability-ng-priority-feed';
import { SettingsStateConfigurationService } from '../../services/settings_state_configuration_service';
import { SettingsCapabilityConfiguration } from '../../settings_configuration';
import { EditPronounsService } from '../../services/edit_pronouns_service';
import { ICommand } from 'core-ts-types';
import { PronounsListQuery } from '../../queries/pronouns_list_query';
import { IPronounsListDatasource } from '../../datasources/pronouns_list_datasource';
import { CustomTextQuery } from 'data-ng-custom-text';
import { PlatformUtility } from 'utility-ts-platform';

export class SettingsFeatureListController {
  private aboutRoute: string;
  private allowUpdateTopic: boolean;
  private allowUpdateNotificationSettings: boolean;
  private showUpdatePreference: boolean = false;
  private allowEditPronouns: boolean = false;
  private selectedPronouns: string;
  private defaultIntakeTitle: string = 'Retake Intake Survey';
  private isMobile: boolean;

  constructor(
    private appConfigModel: any,
    private ngSettingsCapabilityConfiguration: SettingsCapabilityConfiguration,
    private ngSettingsStateConfigurationService: SettingsStateConfigurationService,
    private $state: ng.ui.IStateService,
    private ngPronounsQuery: PronounsQuery,
    private ngEditPronounsService: EditPronounsService,
    private getPronounsListCommand: ICommand,
    private getSTCConfigsCommand: ICommand,
    private ngPronounsListQuery: PronounsListQuery,
    private ngPronounsListDatasource: IPronounsListDatasource,
    private ngCustomTextQuery: CustomTextQuery
  ) {
    this.allowUpdateTopic = this.appConfigModel.isFeatureEnabled('item-show_topics_setting');
    this.allowUpdateNotificationSettings = this.appConfigModel.isFeatureEnabled('notification-settings');
    this.aboutRoute = 'my.about.default';
    this.selectedPronouns = _4.get(this.ngPronounsQuery.result, 'selected_pronouns');
    this.isMobile = PlatformUtility.isMobile();
    this.getSTCConfigsCommand().then((data: any) => {
      this.allowEditPronouns =
        !_4.isEmpty(this.selectedPronouns) && data.show_pronouns && data.allow_users_to_edit_pronouns;
      if (_4.isEmpty(this.ngPronounsListDatasource.read()) && this.allowEditPronouns) {
        this.getPronounsListCommand();
      }
    });
  }

  goToUpdatePreference() {
    const updatePreferenceRoute = this.ngSettingsCapabilityConfiguration.config.hasFirstTerm
      ? this.ngSettingsStateConfigurationService.firstTerm
      : this.ngSettingsStateConfigurationService.intake;
    this.$state.go(updatePreferenceRoute);
  }

  hideUpdatePreference() {
    this.showUpdatePreference = false;
  }

  updatePreferenceConfirmation(): void {
    this.showUpdatePreference = true;
  }

  editPronouns() {
    this.getPronounsListCommand().then(() => {
      this.ngPronounsListQuery.run();
      this.ngEditPronounsService.toggleOpen(true);
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/components/settings_feature_list/settings_feature_list_controller.ts